import React from 'react'
import Layout from './layout'
import supportData from '../components/content/support/support.en-XC.yaml'
import { Link, withAssetPrefix } from 'gatsby'

export default function Support() {
  return (
    <Layout layout="full-width" title={supportData && supportData.title}>
      <section className="section">
        <div className="section__content">
          <h1>{supportData.title}</h1>
          <hr />
          <h2 className="sr-only">{supportData.content.channelsTitle}</h2>
          <div className="grid">
            <div className="grid__item grid__item--6">
              <Link
                className={`block block--outlined block--link block--full-height dx-no-eel-icon ${supportData.content.channelsGeneralClass}`}
                to={supportData.content.channelsGeneralLink}
              >
                <div className="grid">
                  <div className="grid__item grid__item--2">
                    <img
                      className="svg-icon-sm"
                      src={withAssetPrefix('/img/support/FAQ.png')}
                      alt="FAQ's"
                    />
                  </div>
                  <div className="grid__item grid__item--10">
                    <h3
                      className="block__title"
                      data-dxa="faq,faq-click,faq-referrer"
                    >
                      {supportData.content.channelsGeneralTitle}
                    </h3>
                    <p data-dxa="faq,faq-click,faq-referrer">
                      {supportData.content.channelsGeneralBody}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="grid__item grid__item--6">
              <Link
                className={`block block--outlined block--link block--full-height dx-no-eel-icon ${supportData.content.channelsCommunityClass}`}
                to={supportData.content.channelsCommunityLink}
              >
                <div className="grid">
                  <div className="grid__item grid__item--2">
                    <img
                      className="svg-icon-sm"
                      src={withAssetPrefix('/img/support/Community.png')}
                      alt="Forum"
                    />
                  </div>
                  <div className="grid__item grid__item--10">
                    <h3
                      className="block__title"
                      data-dxa="community,community-click,community-referrer"
                    >
                      {supportData.content.channelsCommunityTitle}
                    </h3>
                    <p data-dxa="community,community-click,community-referrer">
                      {supportData.content.channelsCommunityBody}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
          <div className="grid">
            <div className="grid__item grid__item--6">
              <Link
                className={`block block--outlined block--link block--full-height dx-no-eel-icon ${supportData.content.channelsTechClass}`}
                to={supportData.content.channelsTechnicalLink}
                data-dxa="support,support-click,support-referrer"
              >
                <div className="grid">
                  <div className="grid__item grid__item--2">
                    <img
                      className="svg-icon-sm"
                      src={withAssetPrefix('/img/support/MTS.png')}
                      alt="MTS"
                    />
                  </div>
                  <div className="grid__item grid__item--10">
                    <h3
                      className="block__title"
                      data-dxa="support,support-click,support-referrer"
                    >
                      {supportData.content.channelsTechnicalTitle}
                    </h3>
                    <p data-dxa="support,support-click,support-referrer">
                      {supportData.content.channelsTechnicalBody}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="grid__item grid__item--6">
              <a
                className={`block block--outlined block--link block--full-height dx-no-eel-icon ${supportData.content.channelsSalesClass}`}
                data-dxa="support,support-click,support-referrer"
              >
                <div className="grid">
                  <div className="grid__item grid__item--2">
                    <img
                      className="svg-icon-sm"
                      src={withAssetPrefix('/img/support/Call-us.png')}
                      alt="MTS"
                    />
                  </div>
                  <div className="grid__item grid__item--10">
                    <h3
                      className="block__title"
                      data-dxa="support,support-click,support-referrer"
                    >
                      {supportData.content.channelsSalesTitle}
                    </h3>
                    <p data-dxa="support,support-click,support-referrer">
                      {supportData.content.channelsSalesBody}
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}
